<template lang="html">
  <v-page :profile="profile">
    <v-topbar :profile="profile" />

    <v-breadcrumb
      :steps="[
        { label: 'Profissionais', to: { name: 'client-vibbrants' } },
        { label: 'Buscar', to: { name: 'client-search' } },
        { label: 'Requisitar profissionais' },
      ]"
    />
    <v-container>
      <v-row :size="2">
        <v-col :xs="12" :sm="12" :lg="6">
          <v-card class="mb-0 p-3">
            <v-alert class="padding-info">
              <strong>DICA 1: </strong
              ><small
                >Informe para cada profissional
                <b>quantas horas você deseja contratar</b>, bem como uma
                <b>breve descrição do trabalho</b>.</small
              >
            </v-alert>
          </v-card>
        </v-col>
        <v-col :xs="12" :sm="12" :lg="6">
          <v-card class="mb-0 p-3">
            <v-alert class="padding-info">
              <strong>DICA 2: </strong
              ><small
                >Ao requisitar, você abre um canal de comunicação com cada um e
                <b>pode esclarecer suas dúvidas sem compromisso</b>.</small
              >
            </v-alert>
          </v-card>
        </v-col>
      </v-row>
      <v-row :size="2">
        <v-col
          :xs="12"
          :sm="12"
          :lg="12"
          v-for="vibbrante in selectedVibbrantes"
          :key="vibbrante.id"
        >
          <v-card class="mb-0 p-3">
            <v-row :size="2">
              <v-col :xs="12" :sm="12" :lg="6">
                <v-avatar
                  @click="openVibbranteNewTab(vibbrante)"
                  :view="list_view_type"
                  :name="vibbrante.name"
                  :about="vibbrante.profile + '<br>' + vibbrante.focus"
                  class="pointer"
                  :image="vibbrante.avatar"
                >
                  <v-button-remove @click="removeVibbrante(vibbrante)" />
                </v-avatar>
                <v-list class="user-profile mb-0 mt-3">
                  <v-text tag="div"
                    >Experiência:
                    <span>{{ vibbrante.years_experience }} anos</span>
                  </v-text>
                  <v-text tag="div" v-if="!user.hide_value_hour"
                    >Valor/hora:
                    <span>{{ vibbrante.hour_value | currency }}</span>
                  </v-text>
                  <v-text tag="div"
                    >Horas semanais livres:
                    <span>{{ vibbrante.hour_available }}h</span>
                  </v-text>
                </v-list>
              </v-col>
              <v-col :xs="12" :sm="12" :lg="6">
                <v-text class="m-0">
                  Previsão de horas que deseja contratar
                  <v-helper
                    class="text-muted"
                    title="Previsão de horas"
                    placement="top"
                  >
                    Nossos profissionais são sempre contratados por um
                    determinado volume de horas. Informe a previsão de quantas
                    horas você pretende contratar. Isso é apenas um indicador
                    para que o profissional consiga mensurar a disponibilidade
                    para a sua demanda. Caso ainda não tenha decidido quantas
                    horas contratar, pode informar 1h para avançar. Se precisar
                    da nossa ajuda pra essa estimativa, basta solicitar no botão
                    abaixo que a nossa equipe entrará em contato com você!
                  </v-helper>
                </v-text>
                <v-row :size="2">
                  <v-col :xs="12" :sm="3" :md="3">
                    <v-input
                      type="number"
                      min="1"
                      class="m-0"
                      v-model="vibbrante.expect_hours"
                      :disabled="vibbrante.hours_undefined ? 'disabled' : false"
                    ></v-input>
                  </v-col>
                  <v-col :xs="12" :sm="7" :md="7" class="d-flex"> </v-col>
                </v-row>
                <v-divider line :size="2" class="mb-2" />
                <v-input
                  type="textarea"
                  rows="6"
                  v-model="vibbrante.invation_description"
                >
                  Breve descrição do que você espera do
                  <span v-if="vibbrante.vibbrante_type == 'vibbrante'"
                    >Vibbrante</span
                  ><span v-if="vibbrante.vibbrante_type == 'freelancer'"
                    >Talent</span
                  >
                  <v-helper
                    class="text-muted"
                    title="O que você espera do profissional"
                    placement="top"
                  >
                    Informe apenas uma breve descrição do tipo de atividade que
                    você pretende solicitar ao profissional, para que ele se
                    contextualize com o seu projeto ou com a sua expectativa ao
                    contratá-lo. Não se preocupe em detalhar cada atividade ou
                    um escopo de projeto, não é necessário agora.
                  </v-helper>
                </v-input>
              </v-col>
            </v-row>
            <small
              slot="top-left"
              class="badge badge-success"
              v-if="vibbrante.vibbrante_type == 'vibbrante'"
              >{{ vibbrante.vibbrante_type }}!</small
            >
            <small
              slot="top-left"
              class="badge badge-light"
              v-if="vibbrante.vibbrante_type == 'freelancer'"
              >{{ vibbrante.vibbrante_type }}</small
            >
          </v-card>
        </v-col>
      </v-row>
      <v-divider line />
      <v-div class="pb-5 d-flex">
        <v-button
          class="link w-100 w-md-auto ml-auto mr-2"
          :to="{ name: 'client-search' }"
          >Voltar para busca</v-button
        >
        <!-- <v-button class="link w-100 w-md-auto mr-2" :to="{name:'client-search'}">Cancelar requisição</v-button> -->
        <v-button class="primary w-100 w-md-auto" @click="sendInvitations()"
          >Requisitar</v-button
        >
      </v-div>
    </v-container>

    <!-- MODALS -->
    <v-modals
      name="user"
      :show="user_modal_show"
      :data="{ user: selected_vibbrante }"
      @onHide="user_modal_show = false"
    />
    <v-modals
      name="end-user-search"
      :show="end_search_modal_show"
      :data="{}"
      @onHide="goToPendings()"
    />
    <v-modals
      name="cancel-request"
      :show="cancel_request_modal_show"
      :data="{}"
      @onHide="cancel_request_modal_show = false"
    />
    <v-modals
      name="help"
      :show="help_modal_show"
      :data="{}"
      @onHide="help_modal_show = false"
    />
    <v-help
      name="help-review-hour"
      :show="help_review_hour_modal_show"
      :data="{ option: 'Estimativa de horas' }"
      profile="client"
      @onHide="help_review_hour_modal_show = false"
    />
  </v-page>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import FilterBar from '../../../modules/filter-bar';
import ButtonRemove from '../../../modules/button-remove';
import clientAPI from '@/api/client';
import HelpModal from '@/parts/modals/help';

export default {
  props: {
    profile: String,
  },
  components: {
    'v-filter-bar': FilterBar,
    'v-button-remove': ButtonRemove,
    'v-help': HelpModal,
  },
  data() {
    return {
      user_modal_show: false,
      end_search_modal_show: false,
      request_hours: 10,
      request_hours_check: false,
      selected_vibbrante: {},
      cancel_request_modal_show: false,
      help_modal_show: false,
      help_review_hour_modal_show: false,
    };
  },
  methods: {
    showHelp() {
      this.help_review_hour_modal_show = true;
    },
    goToDashboard() {
      this.end_search_modal_show = false;
      this.$router.push({ name: 'client-dashboard' });
    },
    showVibbranteModal(data) {
      this.user_modal_show = true;
      this.selected_vibbrante = data;
    },
    openVibbranteNewTab(data) {
      const routeData = this.$router.resolve({
        // name: "client-search-vibbrante",
        path: '/client/search/vibbrante/' + data.slug,
      });
      window.open(routeData.href, '_blank');
    },
    removeVibbrante(data) {
      this.$store.dispatch('delSelVibbrante', data);
    },
    sendInvitations() {
      let able = true;
      this.$store.getters.selected_vibbrantes.forEach(vibbrante => {
        console.log(vibbrante.expected_hours);
        if (vibbrante.expect_hours === undefined) {
          able = false;
          this.$notify(
            'Informe pelo menos 1 hora para cada profissional selecionado.',
            'error'
          );
        } else if (vibbrante.expect_hours <= 0) {
          able = false;
          this.$notify(
            'Informe pelo menos 1 hora para cada profissional selecionado.',
            'error'
          );
        }
      });
      if (able) {
        clientAPI
          .sendInvitationToVibbrantes(this.$store.getters.selected_vibbrantes)
          .then(response => {
            if (response.status === 200) {
              response.data.forEach((data) => {
                const vibbrante = this.$store.getters.selected_vibbrantes
                  .find((vibbrante) => vibbrante.id == data.vibbrante_id)
                if (data.save) {
                  this.$store.dispatch("delSelVibbrante", vibbrante);
                  return;
                }

                if (data.errors.length > 0) {
                  data.errors.forEach((error) => {
                    this.$notify(`${vibbrante.name} - ${error}`, "error");
                  });
                }
              });

              if (this.$store.getters.selected_vibbrantes.length == 0)
                this.end_search_modal_show = true;
            }
          })
          .catch(e => {
            this.$notify(e, 'error');
          });
      }
    },
    goToPendings() {
      this.end_search_modal_show = false;
      setTimeout(() => {
        this.$router.push({ name: 'client-vibbrants-pending' });
      }, 200);
    },
  },
  computed: {
    ...mapState(['selectedVibbrantes']),
    ...mapGetters(['user']),
  },
};
</script>

<style lang="scss">
.avatar {
  position: relative;
  .avatar-remove {
    position: absolute;
    top: 0;
    right: 0;
    line-height: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    border-radius: 50%;
    font-size: 20px;
    font-family: sans-serif;
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/pages/client/vibbrants/request.vue